import { atom } from "jotai";

export type ItemType = "content" | "timeline";

export type LiveArticleScroller = {
  highlightedEntityId: string;
  isScrolling: boolean;
  toScrollEntityId: string;
  toScrollType: ItemType | null;
};

export type LiveArticleUpdate = {
  highlightedEntityId: string;
  isDatabaseSubscribed: boolean;
  latestLiveContentEntityUuids: string[];
  updatedDate: Date;
};

export const liveArticleScrollerAtom = atom<LiveArticleScroller>({
  highlightedEntityId: "",
  isScrolling: false,
  toScrollEntityId: "",
  toScrollType: null,
});

export const liveArticleUpdateAtom = atom<LiveArticleUpdate>({
  highlightedEntityId: "",
  isDatabaseSubscribed: false,
  latestLiveContentEntityUuids: [],
  updatedDate: new Date(),
});
